import { PauseCircle, PlayCircle } from "@mui/icons-material";
import SoftBox from "components/SoftBox";
import { Button, ButtonBase, createTheme, Grid, IconButton, Slider, styled, Switch, Tab, Tabs, Tooltip, useTheme } from "@mui/material";
import moment from "moment";

const PropTypes = require("prop-types")

const CustomSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-thumb": {
        transition: {
            "transition-behavior": "normal, normal, normal;",
            "transition-duration": "200ms, 200ms, 200ms;",
            "transition-timing-function": "cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1);",
            "transition-delay": "0ms, 0ms, 0ms;",
            "transition-property": "box-shadow, left, bottom;"
        }
    },
    "& .MuiSlider-track": {
        transition: {
            "transition-behavior": "normal, normal, normal;",
            "transition-duration": "200ms, 200ms, 200ms;",
            "transition-timing-function": "cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1), cubic-bezier(0.4, 0, 0.2, 1);",
            "transition-delay": "0ms, 0ms, 0ms;",
            "transition-property": "box-shadow, left, bottom;"
        }
    },
}));

function valueLabelFormat(value) {
    return `${moment(value * 1000).format('hh:mmA, DD/MM/YYYY')}`;
}


function Playback({ startTime, endTime, epoch, toggleIsPlaying, isPlaying }) {
    return (
        <SoftBox sx={{ p: 3 }}>
            <Grid container>
                <Grid item xs={12}>
                    <SoftBox display="flex" justifyContent="center" alignItems="flex-start">
                        <IconButton variant="contained" onClick={toggleIsPlaying} sx={{ fontSize: 50 }} >
                            {isPlaying ? (<PauseCircle />) : (<PlayCircle />)}
                        </IconButton>
                    </SoftBox>
                </Grid>
                <Grid item xs={12}>
                    <SoftBox display="flex" pt={1} justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
                        <Slider sx={{ transition: '1s' }} color="white" min={startTime} max={endTime} value={epoch} getAriaValueText={valueLabelFormat} valueLabelFormat={valueLabelFormat} valueLabelDisplay="auto" />
                    </SoftBox>
                </Grid>
            </Grid>
        </SoftBox>
    )
}

Playback.propTypes = {
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    epoch: PropTypes.number,
    toggleIsPlaying: PropTypes.function,
    isPlaying: PropTypes.bool
}

export default Playback;